import React from 'react';
import { cn } from '../utils/cn';

const PrimaryButton = ({label, className, labelStyle, black = false, onClick}: {label: string, className?: string, labelStyle?: string, black?: boolean, onClick?: () => void}) => {
  return (
    <div onClick={onClick} className={cn([`bg-gradient-to-b ${black ? "from-[#262631] to-[#15141C] border-[#86868f]" : "from-[#8C84FF] to-[#6158E0] border-[#d0cdff]"} text-center cursor-pointer border-x border-t`, className])} >
      <p className={`text-white ${labelStyle}`}>{label}</p>
    </div>
  );
};

export default PrimaryButton;